import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import { connect } from 'react-redux';
import HeaderBack from 'components/components/account/components/HeaderBack';
import withRouter from 'components/components/common/withRouter';
import { setUserLogout } from 'components/actions/authActions';
import merge from 'lodash/merge';
import {
  createSuccessNotification,
  createErrorNotification,
} from 'components/actions/serviceActions';
import ContactFormValidation from './utils/ContactFormValidation';
import originAxios from 'axios';

class Contact extends Component {

  state = {
    name: '',
    email: '',
    message: '',
    sending: false,
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  trans = (key, prefix = 'content.landing.contact') => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  handleChange(key, e) {
    var hash = [];
    hash[key] = e.target.value;
    var newState = merge({}, this.state, hash);
    this.setState(newState);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    var validator = new ContactFormValidation(this.state, this.props.locale);
    if (validator.isValid()) {
      this.setState({ sending: true }, () => this.sendRequest());
    } else {
      this.props.createErrorNotification({
        title: this.t('content.notifications.contact.error'),
        message: validator.getFormErrors()
      })
    }
  }

  sendRequest = () => {
    const { name, email, message } = this.state;
    var params = {
      form: {
        name,
        email,
        message,
        locale: this.props.locale
      }
    };

    originAxios.post('/send-contact-form', params)
      .then(response => {
        this.setState({ email: '', name: '', message: '' });
        this.props.createSuccessNotification({
          title: this.t('content.notifications.contact.success'),
          message: this.t('content.notifications.contact.successMessage'),
        })
        this.setState({ sending: false });
      })
      .catch(err => {
        console.log('err', err);
        this.props.createErrorNotification({
          title: this.t('content.notifications.contact.error'),
          message: this.t('content.notifications.contact.cannotBeSent'),
        })
        this.setState({ sending: false });
      });
  }

  render() {
    const { isLogged } = this.props;
    const { name, email, message, sending } = this.state;
    return (
      <div className="content content--lp content--lp-text">
        {isLogged &&
          <HeaderBack
            locale={this.props.locale}
            name="content.layout.sidebarAndHeader.help"
            link="routes.url.help"
            title="content.layout.sidebarAndHeader.backToHelpTitle"
            className="header-back--lp" />
        }

        <div className="row row--text row--text-wider">
          <div className="headline headline--subpage">
            <h1><T>content.landing.contact.title</T></h1>
            <p><T>content.landing.contact.description</T></p>
          </div>

          <div className="contact">
            <div className="contact__desc">
              <div>
                <h3><T>content.landing.contact.desc.title</T></h3>
                <p><T>content.landing.contact.desc.content</T></p>

                <p className="contact__phone">
                  <a href={`mailto:${this.trans('email', 'content.common.contact')}`}>
                    <T>content.common.contact.email</T>
                  </a>
                </p>

                <p className="no-marg"><T>content.landing.contact.desc.paragraphs.first.title</T></p>
                <p><T>content.landing.contact.desc.paragraphs.first.desc</T></p>
              </div>

              <div>
                <h3><T>content.landing.contact.desc.paragraphs.second.title</T></h3>
              </div>

              <div>
                <h4><T>content.landing.contact.desc.paragraphs.third.title</T></h4>
                <p><T>content.landing.contact.desc.paragraphs.third.desc</T></p>
              </div>

              <div>
                <h4><T>content.landing.contact.desc.paragraphs.fourth.title</T></h4>
                <p><T>content.landing.contact.desc.paragraphs.fourth.desc</T></p>
              </div>
            </div>

            <div className="contact__form">
              <div className="form-contact-wrap">
                <form action="" className="form-contact" onSubmit={this.handleSubmit}>
                  <fieldset>
                    <h2><T>content.landing.contact.form.title</T></h2>
                    <ul>
                      <li>
                        <label htmlFor="contact_name">
                          <T>content.landing.contact.form.inputs.name.label</T>
                        </label>
                        <input
                          type="text"
                          id="contact_name"
                          name="_contact-name"
                          value={name}
                          onChange={this.handleChange.bind(this, "name")}
                          placeholder={this.trans('form.inputs.name.placeholder')}
                          required
                        />
                      </li>

                      <li>
                        <label htmlFor="contact_email">
                          <T>content.landing.contact.form.inputs.email.label</T>
                        </label>
                        <input
                          type="email"
                          id="contact_email"
                          name="_contact_email"
                          value={email}
                          onChange={this.handleChange.bind(this, "email")}
                          placeholder={this.trans('form.inputs.email.placeholder')}
                          required
                        />
                      </li>

                      <li>
                        <label htmlFor="contact_message">
                          <T>content.landing.contact.form.inputs.message.label</T>
                        </label>
                        <textarea
                          type="text"
                          id="contact_message"
                          name="_contact_message"
                          value={message}
                          onChange={this.handleChange.bind(this, "message")}
                          placeholder={this.trans('form.inputs.message.placeholder')}
                          required
                        />
                      </li>
                    </ul>

                    <p className="text-center">
                      <button type="submit" className="button" disabled={sending}>
                        {
                          sending
                            ?
                            <T>content.landing.contact.form.inputs.sendingButton</T>
                            :
                            <T>content.landing.contact.form.inputs.sendButton</T>
                        }
                      </button>
                    </p>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout, createSuccessNotification, createErrorNotification }
  )(Contact));
